import {branch, withProps, renderComponent} from 'recompose'

import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import withEffect from '../../../../hocs/withEffect'
import type {State} from '../../../../reducers/types'
import {getExtensionEndpoint} from '../../../../selectors'
import {fetchBuildLogMessages} from '../BuildLog.actions'
import {
  getBuildLogMessages,
  getBuildLogTestAnchorPosition,
  getBuildLogLastMessageIncluded,
} from '../BuildLog.selectors'
import {TestTargetAnchorType} from '../BuildLog.types'
import {getKeyForBuildLogData} from '../BuildLog.utils'
import BuildLogInfo from '../BuildLogInfo/BuildLogInfo'

import BuildLogPreview from './BuildLogPreview'
import type {ReduxOwnProps, StateProps, Props, OwnProps} from './BuildLogPreview.types'

const actionCreators = {
  fetchBuildLogMessages,
}

const mapStateToProps = (state: State, {buildLogKey}: ReduxOwnProps): StateProps => {
  const {data: messages, loading} = getBuildLogMessages(state, buildLogKey) ?? {
    data: null,
    loading: false,
  }
  const testLogAnchorPosition = getBuildLogTestAnchorPosition(
    state,
    buildLogKey,
    TestTargetAnchorType.TEST_EXCEPTION,
  )
  const hasExpectedState = Boolean(
    getBuildLogTestAnchorPosition(state, buildLogKey, TestTargetAnchorType.TEST_EXPECTED),
  )
  const hasActualState = Boolean(
    getBuildLogTestAnchorPosition(state, buildLogKey, TestTargetAnchorType.TEST_ACTUAL),
  )
  return {
    extensionEnabled: Boolean(getExtensionEndpoint(state, 'fetchExpandedBuildLogMessage')),
    messages,
    loading,
    testLogAnchorPosition,
    showDiffBetweenTestValues: hasExpectedState && hasActualState,
    lastMessageIncluded: getBuildLogLastMessageIncluded(state, buildLogKey) ?? true,
  }
}

export default compose(
  withProps(({buildId, buildLogKey}: OwnProps) => ({
    buildLogKey:
      buildLogKey ??
      getKeyForBuildLogData({
        type: 'preview',
        id: buildId,
      }),
  })),
  connect(mapStateToProps, actionCreators),
  branch(
    (props: Props) => !props.extensionEnabled,
    renderComponent(({className}: Props) => <BuildLogInfo className={className} type="disabled" />),
  ),
  withEffect(
    (props: Props) => props.buildId,
    props => props.fetchBuildLogMessages,
    props => props.buildLogKey,
    props => props.focusLine,
    props => props.expandLine,
    props => props.problemOccurrenceId,
    props => props.withLoadingData,
    (id, fetch, buildLogKey, focusLine, expandLine, problemOccurrenceId, withLoadingData) => {
      withLoadingData === true &&
        focusLine != null &&
        fetch({
          buildId: id,
          buildLogKey,
          options: {
            logAnchor: Number(focusLine),
            expandState: [Number(expandLine)],
            problemOccurrenceId,
            count: 1000,
          },
        })
    },
  ),
)(BuildLogPreview)
